import { useEffect, useState } from 'react';
import api from '../api/client';
import { useFincaId } from '../context/FincaContext';

export default function Sectores() {
  const fincaIdContext = useFincaId();

  const [sectores, setSectores] = useState([]);
  const [editando, setEditando] = useState(null);
  const [form, setForm] = useState({ nombre: '' });
  const [mostrarModal, setMostrarModal] = useState(false);
  const [mensaje, setMensaje] = useState(null);
  const [fincaId, setFincaId] = useState(null);

  useEffect(() => {
    if (fincaIdContext) {
      setFincaId(fincaIdContext);
      cargar(fincaIdContext);
    } else {
      setSectores([]);
      setMensaje({ tipo: 'error', texto: 'No hay finca seleccionada' });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fincaIdContext]);

  const cargar = async (idFinca) => {
    try {
      const { data } = await api.get(`/sectores/finca/${idFinca}`);
      setSectores(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error('Error cargando sectores:', err);
      setMensaje({ tipo: 'error', texto: 'Error al cargar sectores' });
    }
  };

  const abrirNueva = () => {
    setEditando(null);
    setForm({ nombre: '' });
    setMostrarModal(true);
  };

  const abrirEditar = (s) => {
    setEditando(s);
    setForm({ nombre: s.nombre });
    setMostrarModal(true);
  };

  const guardar = async (e) => {
    e.preventDefault();
    setMensaje(null);
    try {
      if (editando) {
        await api.put(`/sectores/${editando.id}`, form);
      } else {
        await api.post('/sectores', { ...form, finca_id: fincaId });
      }
      setMostrarModal(false);
      await cargar(fincaId);
      setMensaje({ tipo: 'ok', texto: 'Guardado correctamente' });
      setTimeout(() => setMensaje(null), 2000);
    } catch (err) {
      setMensaje({
        tipo: 'error',
        texto: err.response?.data?.error || 'Error al guardar',
      });
    }
  };

  const eliminar = async (s) => {
    if (
      !confirm(
        `¿Eliminar el sector "${s.nombre}"? Las piscinas dentro también se ocultarán.`
      )
    )
      return;
    try {
      await api.delete(`/sectores/${s.id}`);
      await cargar(fincaId);
      setMensaje({ tipo: 'ok', texto: 'Sector eliminado' });
      setTimeout(() => setMensaje(null), 2000);
    } catch (err) {
      console.error(err);
      setMensaje({ tipo: 'error', texto: 'Error al eliminar' });
    }
  };

  return (
    <div className="p-6">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-xl font-semibold text-gray-700">Sectores</h2>
        <button
          onClick={abrirNueva}
          className="px-4 py-2 bg-primary text-white rounded hover:bg-blue-800"
        >
          + Nuevo sector
        </button>
      </div>

      {mensaje && (
        <div
          className={`mb-4 p-3 rounded ${
            mensaje.tipo === 'ok'
              ? 'bg-green-100 text-green-800'
              : 'bg-red-100 text-red-800'
          }`}
        >
          {mensaje.texto}
        </div>
      )}

      {sectores.length === 0 ? (
        <div className="bg-white p-6 rounded shadow text-center text-gray-500">
          No hay sectores registrados. Crea el primero con el botón &quot;+ Nuevo
          sector&quot;.
        </div>
      ) : (
        <div className="bg-white rounded shadow overflow-hidden">
          <table className="w-full">
            <thead className="bg-gray-100">
              <tr>
                <th className="text-left px-4 py-3 text-sm font-semibold">
                  Nombre
                </th>
                <th className="text-right px-4 py-3 text-sm font-semibold">
                  Acciones
                </th>
              </tr>
            </thead>
            <tbody>
              {sectores.map((s) => (
                <tr key={s.id} className="border-t hover:bg-gray-50">
                  <td className="px-4 py-3 font-medium">{s.nombre}</td>
                  <td className="px-4 py-3 text-right">
                    <button
                      onClick={() => abrirEditar(s)}
                      className="text-blue-600 hover:underline mr-3"
                    >
                      Editar
                    </button>
                    <button
                      onClick={() => eliminar(s)}
                      className="text-red-600 hover:underline"
                    >
                      Eliminar
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {mostrarModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-lg shadow-xl p-6 w-full max-w-md">
            <h2 className="text-xl font-bold mb-4">
              {editando ? 'Editar sector' : 'Nuevo sector'}
            </h2>
            <form onSubmit={guardar}>
              <label className="block mb-4">
                <span className="text-sm font-medium">Nombre del sector</span>
                <input
                  type="text"
                  value={form.nombre}
                  onChange={(e) => setForm({ ...form, nombre: e.target.value })}
                  placeholder="Ej: Sector A, Estanque Norte, etc."
                  className="mt-1 w-full px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-primary"
                  required
                  autoFocus
                />
              </label>
              <div className="flex justify-end gap-2">
                <button
                  type="button"
                  onClick={() => setMostrarModal(false)}
                  className="px-4 py-2 border rounded hover:bg-gray-100"
                >
                  Cancelar
                </button>
                <button
                  type="submit"
                  className="px-4 py-2 bg-primary text-white rounded hover:bg-blue-800"
                >
                  Guardar
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}